// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2eBld","Open":"SideDrawer_Open__jZqiV","Close":"SideDrawer_Close__3r8gk","Logo":"SideDrawer_Logo__29JET"};